import React from 'react';
import ModuleTable from 'Components/Core/ModuleTable';
import BankSyncModal from 'Components/Banking/BankSyncModal';
import BankSyncAllModal from 'Components/Banking/BankSyncAllModal';
import BankTransferModal from 'Components/Banking/BankTransferModal';
import BankTransactionDetailModal from 'Components/Banking/BankTransactionDetailModal';
import BankImportModal from 'Components/Banking/BankImportModal';
import './BankTransactions.css';

// Reine String-Umformung statt Date-Objekt/toLocaleDateString(): bookingdate
// kommt als reines Datum ("YYYY-MM-DD") ohne Uhrzeit - ueber ein Date-Objekt
// zu gehen interpretiert das als UTC-Mitternacht, was in Zeitzonen westlich
// von UTC den angezeigten Tag verschieben kann.
function formatGermanDate(isoDate) {
	if (!isoDate) return '';
	const parts = isoDate.split('-');
	if (parts.length !== 3) return isoDate;
	const [year, month, day] = parts;
	return `${day}.${month}.${year}`;
}

export default function BankTransactions(props) {

	const x = props.x;

	const [reloadKey, setReloadKey] = React.useState(0);
	const [showSync, setShowSync] = React.useState(false);
	const [showTransfer, setShowTransfer] = React.useState(false);
	const [showImport, setShowImport] = React.useState(false);
	const [transferPrefill, setTransferPrefill] = React.useState(null);
	const [detailTransaction, setDetailTransaction] = React.useState(null);
	const [connections, setConnections] = React.useState(null);
	// '' = alle Konten zusammen (bisheriges Standardverhalten) - kein
	// connectionid-Filter wird an das Backend geschickt.
	const [connectionId, setConnectionId] = React.useState('');
	const [pinUse, setPinUse] = React.useState(null);

	React.useEffect(() => {
		x.was.axGet('Backend/webapp.php?module=Banking&task=BankingConnectionList', (result) => {
			if (result.data['returncode'] === 1) setConnections(result.data['content']);
		});
		x.was.axPost('Backend/webapp.php?module=Banking&task=BankingPinSwitch', {}, (result) => {
			setPinUse(result.data.returncode === 1 && parseInt(result.data.content.enabled, 10) === 1);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const selectedConnection = connections ? connections.find((c) => c.connectionid === parseInt(connectionId, 10)) : null;

	function afterSync() {
		setShowSync(false);
		setReloadKey((current) => current + 1);
	}

	function afterTransfer() {
		setShowTransfer(false);
		setTransferPrefill(null);
		setReloadKey((current) => current + 1);
	}

	function openTransfer(prefill) {
		setTransferPrefill(prefill || null);
		setShowTransfer(true);
	}

	function newTransferFromTransaction(transaction) {
		setDetailTransaction(null);
		openTransfer({
			connectionId: transaction.sourceconnectionid,
			recipientName: transaction.counterpartyname || '',
			recipientIban: transaction.counterpartyiban || '',
			amount: transaction.amount ? Math.abs(parseFloat(transaction.amount)).toString() : '',
			purpose: transaction.purpose || '',
		});
	}

	function afterImport() {
		setShowImport(false);
		setReloadKey((current) => current + 1);
	}

	function switchConnection(id) {
		if (id === connectionId) return;
		setConnectionId(id);
		setReloadKey((current) => current + 1);
	}

	return (
		<React.Fragment>
			<ModuleTable
				id={props.id}
				tableId="transactionid"
				x={x}
				classes="module-banking-transactions"
				tableClasses="banking-transactions-table"
				title={props.title}
				hideAddButton={true}
				module="Banking"
				listTask="BankingTransactionList"
				listParams={connectionId === '' ? '' : '&connectionid=' + connectionId}
				filterableColumns={['konto', 'counterpartyname', 'purpose', 'amount']}
				reloadKey={reloadKey}
				extraToolbar={
					<span
						className="bi bi-arrow-repeat module-icon"
						title={connectionId === '' ? 'Umsätze aller Konten abrufen' : 'Umsätze dieses Kontos abrufen'}
						onClick={() => setShowSync(true)}
					></span>
				}
				toolbar={
					<div className="banking-transactions-toolbar">
						{connections && connections.length > 1 &&
							<div className="banking-connection-switch">
								<label htmlFor="banking-transactions-connection-select">Konto</label>
								<select
									id="banking-transactions-connection-select"
									value={connectionId}
									onChange={(e) => switchConnection(e.target.value)}
								>
									<option value="">Alle Konten</option>
									{connections.map((c) => (
										<option key={c.connectionid} value={c.connectionid}>{c.accountlabel}</option>
									))}
								</select>
							</div>
						}
						<div className="banking-transactions-actions">
							<button type="button" className="btn banking-transfer-button" onClick={() => openTransfer(null)}>
								<i className="bi bi-send"></i> Überweisung
							</button>
							<button type="button" className="btn banking-transfer-button" onClick={() => setShowImport(true)}>
								<i className="bi bi-file-earmark-arrow-up"></i> Import
							</button>
						</div>
					</div>
				}
				onAddHeader={(addHeader) => {
					addHeader('Datum');
					addHeader('Konto');
					addHeader('Betrag');
					addHeader('Empfänger/Auftraggeber');
					addHeader('Verwendungszweck');
				}}
				onAddColumn={(key, value) => {
					switch (key) {
						case 'transactionid':
						case 'valuedate':
						case 'currency':
						case 'bankreference':
						case 'counterpartyiban':
						case 'sourceconnectionid':
							return false;
						case 'bookingdate':
							return formatGermanDate(value);
						case 'konto':
						case 'counterpartyname':
						case 'purpose':
							return value;
						case 'amount':
							return <span className={parseFloat(value) < 0 ? 'amount-negative' : 'amount-positive'}>{value} €</span>;
						default:
							return false;
					}
				}}
				onRowClick={(e, item) => setDetailTransaction(item)}
			/>
			{showSync && connectionId !== '' &&
				<BankSyncModal
					x={x}
					connectionId={parseInt(connectionId, 10)}
					accountLabel={selectedConnection ? selectedConnection.accountlabel : ''}
					pinUse={pinUse === true}
					pinStored={selectedConnection ? parseInt(selectedConnection.pinstored, 10) === 1 : false}
					onClose={() => setShowSync(false)}
					onSuccess={afterSync}
				/>
			}
			{showSync && connectionId === '' &&
				<BankSyncAllModal
					x={x}
					onClose={() => setShowSync(false)}
					onSuccess={afterSync}
				/>
			}
			{showTransfer &&
				<BankTransferModal
					x={x}
					connections={connections}
					prefill={transferPrefill}
					onClose={() => { setShowTransfer(false); setTransferPrefill(null); }}
					onSuccess={afterTransfer}
				/>
			}
			{showImport &&
				<BankImportModal
					x={x}
					connections={connections}
					onClose={() => setShowImport(false)}
					onSuccess={afterImport}
				/>
			}
			{detailTransaction &&
				<BankTransactionDetailModal
					x={x}
					transaction={detailTransaction}
					onClose={() => setDetailTransaction(null)}
					onNewTransfer={() => newTransferFromTransaction(detailTransaction)}
				/>
			}
		</React.Fragment>
	)

};
